module.exports = __webpack_public_path__ + "f3e7be0ed9627914365d0a98b7c59216.fbx";